module.exports = __webpack_public_path__ + "static/idle.2be550d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/examples/microwave-example/idle.jpg
// module id = 1008
// module chunks = 240162396545425